






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { RelatedProductInterface } from '@plugin/Common/interfaces/related-products/related-product.interface'
import { relatedProductsService } from '@plugin/Common/services/related-products/related-products.service'
import RelatedProductsGrid from '@plugin/Common/components/related-products/RelatedProductsGrid.vue'
import RelatedProductsLoader from '@plugin/Common/components/related-products/RelatedProductsLoader.vue'

@Component({
  components: {
    RelatedProductsGrid,
  },
})
export default class RelatedProductsComponent extends Vue {
  @Prop({
    required: true,
    type: Number,
  })
  public productId: number

  @Prop({
    type: String,
    default: 'Related Products',
  })
  public title: string

  public apiError: Error | null = null

  public apiLoading = false

  public products: RelatedProductInterface[] = []

  mounted() {
    if (this.productId) {
      this.retrieveRelatedProducts(this.productId)
    }
  }

  get hasProducts(): boolean {
    return !this.apiLoading && !this.apiError && this.products.length > 0
  }

  async retrieveRelatedProducts(productId: number): Promise<void> {
    if (!productId) {
      return
    }

    this.apiLoading = true
    try {
      const relatedProducts = await relatedProductsService.getRelatedProductsById(productId)
      this.products = relatedProducts
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      this.apiError = err
    }
    this.apiLoading = false
  }
}
